import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/es.string.includes.js';
import 'core-js/modules/es.object.assign.js';
import { __awaiter } from '../../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { useContainer } from '@hub-la/fe-container';
import { Auth } from '@hub-la/fe-core-auth';
import { useState, useEffect, useCallback, createContext } from 'react';
import useLocalStorage from 'use-local-storage';
import { UpdatedTokenAttributes } from '../../usecases/updated-token-attributes.js';
import { useSigninRoleplay } from '../hooks/use-signin-roleplay.js';
import { useSignOutRoleplay } from '../hooks/use-signout-roleplay.js';

const RoleplayPermissionContext = /*#__PURE__*/createContext({
  roleplayUserId: null,
  permissions: [],
  isRoleplay: false,
  signInLoading: false,
  signOutLoading: false,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  signIn: () => __awaiter(void 0, void 0, void 0, function* () {}),
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  signOut: () => __awaiter(void 0, void 0, void 0, function* () {}),
  hasPermission: () => false
});
const RoleplayPermissionProvider = ({
  children
}) => {
  const container = useContainer();
  const auth = container.get(Auth);
  const {
    mutateAsync: postSignIn,
    isLoading: signInLoading
  } = useSigninRoleplay();
  const {
    mutateAsync: postSignOut,
    isLoading: signOutLoading
  } = useSignOutRoleplay();
  const [roleplayUserId, setRoleplayUserId] = useState(null);
  const [permissions, setPermissions] = useState([]);
  const [isRoleplay, setIsRoleplay] = useLocalStorage('isRoleplay', false);
  useEffect(() => {
    if (roleplayUserId === null) return;
    setIsRoleplay(!!roleplayUserId);
  }, [roleplayUserId, setIsRoleplay]);
  const updateRoleplayAttributes = () => __awaiter(void 0, void 0, void 0, function* () {
    const tokenAttributes = yield new UpdatedTokenAttributes(auth).execute();
    if (!tokenAttributes) {
      setPermissions([]);
      setRoleplayUserId(null);
      setIsRoleplay(undefined);
      return;
    }
    const {
      roleplayResources,
      roleplayUserId
    } = tokenAttributes;
    setPermissions(roleplayResources);
    setRoleplayUserId(roleplayUserId);
  });
  const signIn = useCallback(id => __awaiter(void 0, void 0, void 0, function* () {
    const token = yield postSignIn(id);
    yield auth.signInWithToken(token);
    yield updateRoleplayAttributes();
  }), [auth, postSignIn]);
  const hasPermission = permission => {
    if (!isRoleplay) return true;
    if (Array.isArray(permission)) {
      return permission.some(p => permissions.includes(p));
    }
    return permissions.includes(permission);
  };
  const signOut = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
    const token = yield postSignOut();
    yield auth.signInWithToken(token);
    yield updateRoleplayAttributes();
  }), [auth, postSignOut]);
  useEffect(() => {
    updateRoleplayAttributes();
    const unsubscribe = auth.listen(() => {
      updateRoleplayAttributes();
    });
    return () => unsubscribe;
  }, []);
  return jsx(RoleplayPermissionContext.Provider, Object.assign({
    value: {
      roleplayUserId,
      permissions,
      isRoleplay: !!isRoleplay,
      signIn,
      signOut,
      hasPermission,
      signInLoading,
      signOutLoading
    }
  }, {
    children: children
  }));
};

export { RoleplayPermissionContext, RoleplayPermissionProvider };
